
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93DqVVSEmuUf_8SPRRZhKau5lUWbBfH0MFPdJEp6sGHnIMeta } from "/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue?macro=true";
import { default as _91location_93V7hRT0h4UguI6mx2lu8pldzDa2E1M3g8sxWCTaCllKwMeta } from "/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue?macro=true";
import { default as _91product_id_93lEJ7KolKVWexWTjYHUP4nSVJyaf355vG6kBv9lGFh9QMeta } from "/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue?macro=true";
import { default as component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta } from "/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.0.15_db0@0.3.2_es_02faacb384bf43dc81dfa2d8b50dca67/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA } from "/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.0.15_db0@0.3.2_es_02faacb384bf43dc81dfa2d8b50dca67/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___us",
    path: "/us/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___au",
    path: "/au/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ca",
    path: "/ca/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ie",
    path: "/ie/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___nz",
    path: "/nz/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___za",
    path: "/za/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___cl",
    path: "/cl/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ar",
    path: "/ar/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___mx",
    path: "/mx/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ca-fr",
    path: "/ca-fr/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ch",
    path: "/ch/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ch-fr",
    path: "/ch-fr/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___br",
    path: "/br/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___be-nl",
    path: "/be-nl/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___hu",
    path: "/hu/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___cy",
    path: "/cy/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___gr",
    path: "/gr/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___jp",
    path: "/jp/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___hr",
    path: "/hr/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___bg",
    path: "/bg/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___cz",
    path: "/cz/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___dk",
    path: "/dk/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ee",
    path: "/ee/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___fi",
    path: "/fi/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___lv",
    path: "/lv/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___lt",
    path: "/lt/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___sk",
    path: "/sk/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___si",
    path: "/si/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___se",
    path: "/se/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___al",
    path: "/al/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___ba",
    path: "/ba/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___is",
    path: "/is/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___lu",
    path: "/lu/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___rs",
    path: "/rs/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___tr",
    path: "/tr/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[...slug].vue")
  },
  {
    name: "type-location___us",
    path: "/us/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___uk",
    path: "/uk/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___au",
    path: "/au/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ca",
    path: "/ca/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ie",
    path: "/ie/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___nz",
    path: "/nz/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___za",
    path: "/za/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___es",
    path: "/es/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___cl",
    path: "/cl/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ar",
    path: "/ar/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___mx",
    path: "/mx/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___fr",
    path: "/fr/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ca-fr",
    path: "/ca-fr/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___be",
    path: "/be/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___de",
    path: "/de/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ch",
    path: "/ch/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ch-fr",
    path: "/ch-fr/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___at",
    path: "/at/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___pt",
    path: "/pt/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___br",
    path: "/br/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___it",
    path: "/it/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___nl",
    path: "/nl/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___be-nl",
    path: "/be-nl/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___pl",
    path: "/pl/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___hu",
    path: "/hu/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___cy",
    path: "/cy/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___gr",
    path: "/gr/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___jp",
    path: "/jp/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___hr",
    path: "/hr/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___bg",
    path: "/bg/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___cz",
    path: "/cz/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___dk",
    path: "/dk/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ee",
    path: "/ee/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___fi",
    path: "/fi/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___lv",
    path: "/lv/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___lt",
    path: "/lt/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___sk",
    path: "/sk/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___si",
    path: "/si/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___se",
    path: "/se/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___al",
    path: "/al/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___ba",
    path: "/ba/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___is",
    path: "/is/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___lu",
    path: "/lu/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___rs",
    path: "/rs/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___tr",
    path: "/tr/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-location___en",
    path: "/:type()/:location()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[location].vue")
  },
  {
    name: "type-country-product-product_id___us",
    path: "/us/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___uk",
    path: "/uk/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___au",
    path: "/au/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ca",
    path: "/ca/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ie",
    path: "/ie/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___nz",
    path: "/nz/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___za",
    path: "/za/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___es",
    path: "/es/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___cl",
    path: "/cl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ar",
    path: "/ar/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___mx",
    path: "/mx/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___fr",
    path: "/fr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ca-fr",
    path: "/ca-fr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___be",
    path: "/be/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___de",
    path: "/de/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ch",
    path: "/ch/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ch-fr",
    path: "/ch-fr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___at",
    path: "/at/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___pt",
    path: "/pt/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___br",
    path: "/br/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___it",
    path: "/it/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___nl",
    path: "/nl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___be-nl",
    path: "/be-nl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___pl",
    path: "/pl/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___hu",
    path: "/hu/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___cy",
    path: "/cy/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___gr",
    path: "/gr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___jp",
    path: "/jp/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___hr",
    path: "/hr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___bg",
    path: "/bg/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___cz",
    path: "/cz/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___dk",
    path: "/dk/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ee",
    path: "/ee/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___fi",
    path: "/fi/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___lv",
    path: "/lv/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___lt",
    path: "/lt/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___sk",
    path: "/sk/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___si",
    path: "/si/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___se",
    path: "/se/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___al",
    path: "/al/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___ba",
    path: "/ba/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___is",
    path: "/is/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___lu",
    path: "/lu/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___rs",
    path: "/rs/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___tr",
    path: "/tr/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: "type-country-product-product_id___en",
    path: "/:type()/:country()/:product()/:product_id()",
    component: () => import("/codebuild/output/src2634972645/src/bitbucket.org/magusa/cavu-workspaces/apps/l4/pages/[type]/[country]/[product]/[product_id].vue")
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/us/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/uk/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/au/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ca/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ie/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/nz/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/za/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/cl/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/mx/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ca-fr/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/be/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ch/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ch-fr/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/at/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/br/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/be-nl/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/pl/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/hu/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/cy/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/gr/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/jp/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/hr/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/bg/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/cz/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/dk/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ee/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/fi/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/lv/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/lt/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/sk/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/si/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/se/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/al/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/ba/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/is/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/lu/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/rs/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  },
  {
    name: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub9c41t_VoeWrKJO_CGPPfQoIzDhEEbGpJ1HbsJH0qPcA
  }
]